'use client';

import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  return (
    <header className="fixed top-0 w-full z-50 px-4 md:px-6 h-16 flex items-center justify-between"
      style={{ background: 'rgba(12,10,14,0.85)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
      <AppLogo
        src="/assets/images/logo2-1771848081774.png"
        size={56}
        className="text-white"
      />
      <a
        href="#registration-form"
        className="btn-primary text-sm font-semibold px-5 py-2.5 rounded-full"
      >
        Jetzt kostenlos anmelden
      </a>
    </header>
  );
}